import { unparse as convertToCSV } from "papaparse/papaparse.min";
import moment from "moment";
import { downloadCsv } from "../../utils";

export const exporter = (data) => {
    const dataForExport = data.map((item) => ({
      Nome: item.name,
      Descrição: item.description,
      URL: item.url,
      Laboratório: item.lab ? item.lab.name : "",
      'Código da Amostra': item.sample_id,
      'Código EAN': item.ean || "Não coletado",
    }));
  
    const csv = convertToCSV(
      {
        data: dataForExport,
        fields: ["Nome", "Descrição", "URL", "Laboratório", "Código da Amostra", "Código EAN"], // order fields in the export
      },
      { delimiter: ";" }
    );

  const filename = `Extracao_Amostras_${moment().format('YYYYMMDD')}`;
  downloadCsv(csv, filename);
  };
  